import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { EddEmbeddedFields } from '../../embedded/fields.types';
import { useFundingSourcesLogic } from './hooks/useFundingSourcesLogic';
import { FundingSourcesForm } from './FundingSourcesForm';

export const EddFundingSources = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading, optionsList } = useFundingSourcesLogic();

  const selectedOptions = formMethods.watch(EddEmbeddedFields.EDD_FUNDING_SOURCES_SELECTED);

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('organic.fundingSources.title')}
        text={t('organic.fundingSources.subtitle')}
        textCustomStyle='mt-[16px] text-text-main-primary text-[16px]'>
        <FundingSourcesForm selectedOptions={selectedOptions} optionsList={optionsList} />
      </StepPageWrapper>
    </FormProvider>
  );
};
